import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createPost } from '../../store/actions/postActions';
import { Redirect, withRouter } from 'react-router-dom';
import CustomUploadButton from 'react-firebase-file-uploader/lib/CustomUploadButton';
import firebase from "firebase";

import * as ROUTES from '../../constants/routes';

class NewPost extends Component {
    constructor(props) {
        super();
    }

    state = {
        title: '',
        content: '',
        avatar: '',
        isUploading: false,
        progress: 0,
        avatarURL: ''
    }
    
    handleChange = (e) => {
        this.setState({ [e.target.id]:[e.target.value] })
    }

    handleSubmit = (e) => {
        e.preventDefault();

        this.props.createPost(this.state);
        this.props.history.push(ROUTES.SIGNIN);  
    };
    
    handleUploadStart = () => this.setState({ isUploading: true, progress: 0 });

    handleProgress = progress => this.setState({ progress });

    handleUploadError = error => {
        this.setState({ isUploading: false });
        console.error(error);
    };

    handleUploadSuccess = filename => {

        this.setState({ avatar: filename, progress: 100, isUploading: false });
        firebase
        .storage()
        .ref("images")
        .child(filename)
        .getDownloadURL()
        .then(url => this.setState({ avatarURL: url }));
    };

    render() {
        const { auth } = this.props;

        if (!auth.uid) return <Redirect to={ROUTES.SIGNIN} />;

        return (
            <div className="" >
                <div className="credentials-form create-post card feed-card" >
                    <div className="card-header">
                        <ul className="nav nav-tabs card-header-tabs" id="myTab" role="tablist">
                            <li className="nav-item">
                                <a className="nav-link active disabled" id="posts-tab" data-toggle="tab" href="/" role="tab" aria-controls="posts" aria-selected="true">Add a new post</a>
                            </li>
                        </ul>
                    </div>
                    <div className="card-body" style={{ marginBottom: "0", paddingBottom: "5px" }}>
                    <form onSubmit={this.handleSubmit} className="form-group" style={{ marginBottom: "0", paddingBottom: "5px" }}>
                            <div className="tab-content" id="myTabContent">
                                <div className="tab-pane fade show active" id="posts" role="tabpanel" aria-labelledby="posts-tab">
                                    <div className="form-group">
                                        <label className="sr-only" htmlFor="title">post</label>
                                        <input 
                                            className="form-control" 
                                            id="title" 
                                            rows="3" 
                                            placeholder="Title"
                                            onChange={this.handleChange}
                                        >
                                        </input>
                                    </div>
                                    <div className="form-group">
                                        <label className="sr-only" htmlFor="content">post</label>
                                        <textarea 
                                            className="form-control" 
                                            id="content" 
                                            rows="3" 
                                            placeholder="Description"
                                            maxLength="144"
                                            onChange={this.handleChange}
                                        >
                                        </textarea>
                                    </div>
                                </div>
                            </div>
                            {this.state.isUploading && <p>Progress: {this.state.progress}</p>}
                            {this.state.avatarURL && <img src={this.state.avatarURL} alt="uploaded" style={{ maxWidth: "300px", maxHeight: "300px" }} />}
                            {!this.state.avatarURL && 
                                <CustomUploadButton
                                    accept="image/*"
                                    storageRef={firebase.storage().ref('images')}
                                    onUploadStart={this.handleUploadStart}
                                    onUploadError={this.handleUploadError}
                                    onUploadSuccess={this.handleUploadSuccess}
                                    onProgress={this.handleProgress}
                                    style={{backgroundColor: '#343a40', color: 'white', padding: 5, borderRadius: 4, fontSize: 10 }}
                                >Add Image
                                </CustomUploadButton>
                            }
                            <hr />
                            <div className="btn-toolbar justify-content-between">
                                <div className="btn-group">
                                    <button type="submit" className="btn btn-primary" style={{width: 100}}>Post</button>
                                </div>
                            </div>
                            </form>
                        </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.firebase.auth
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        createPost: (post) => dispatch(createPost(post))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(NewPost));